import { ActionReducerMap } from '@ngrx/store';
import * as fromDeliveryDates from './replacement.delivery.dates.reducer';
import * as fromSelected from './selected.reducer';

export interface ProductDetailsState {
  readonly deliveryDates: fromDeliveryDates.DeliveryDatesState;
  readonly selected: fromSelected.SelectedState;
}

export const productDetailsReducers: ActionReducerMap<ProductDetailsState> = {
  deliveryDates: fromDeliveryDates.reducer,
  selected: fromSelected.reducer,
};

export const PRODUCT_DETAILS_FEATURE = 'productDetails';
